import React, { useEffect, useRef, useState } from "react";
import Lottie from "lottie-react";
import introAnimation from "../../media/animations/intro.json";

const Intro = () => {
  const lottieRef = useRef();

  const [showOverlay, setShowOverlay] = useState(false);
  const [shouldPlayIntro, setShouldPlayIntro] = useState(false);
  const [slidingUp, setSlidingUp] = useState(false);
  const [isChecking, setIsChecking] = useState(true); // evita flash

  // Decide se mostrare l'intro
  useEffect(() => {
    const saved = localStorage.getItem("intro-settings");

    if (saved && new Date().getTime() < parseInt(saved)) {
      setShouldPlayIntro(false);
      setShowOverlay(false);
      setIsChecking(false);
      return;
    }

    // Intro deve partire
    setShouldPlayIntro(true);
    setShowOverlay(true);
    document.body.style.overflow = "hidden";
    document.body.style.background = "#1A1A1A";

    setIsChecking(false);
  }, []);

  // Velocita animazione: usa la velocita originale del Lottie
  useEffect(() => {
    if (!shouldPlayIntro || !lottieRef.current) return;
    // +60% speed (leggermente piu veloce)
    lottieRef.current.setSpeed(1.6);
  }, [shouldPlayIntro]);

  const handleFinish = () => {
    localStorage.setItem(
      "intro-settings",
      new Date().getTime() + 3600 * 24 * 1000
    );

    // Attiva slide-up
    setSlidingUp(true);

    setTimeout(() => {
      setShouldPlayIntro(false);
      setShowOverlay(false);
      document.body.style.overflow = "";
      document.body.style.background = "";
    }, 600);
  };

  // Prima che sappiamo cosa fare: non rendere nulla
  if (isChecking) {
    return <div style={styles.initialOverlay} />;
  }

  // Intro non necessaria
  if (!shouldPlayIntro) return null;

  return (
    <div
      style={{
        ...styles.wrapper,
        ...(slidingUp && styles.slideUp), // aggiunta animazione slide
      }}
      className="intro-wrapper"
    >
      <div className="intro-animation-wrapper" style={styles.animationWrapper}>
        <Lottie
          lottieRef={lottieRef}
          animationData={introAnimation}
          loop={false}
          autoplay
          onComplete={handleFinish}
        />
      </div>

      {/* Fade overlay */}
      <div className="fade-layer"></div>

      {/* CSS inline */}
      <style>
        {`
          .intro-wrapper {
            animation: fadeIn 0.3s ease forwards;
          }

          .fade-layer {
            position: absolute;
            inset: 0;
            background: #1A1A1A;
            opacity: 0;
            pointer-events: none;
            transition: opacity .4s ease;
          }

          /* Responsive sizes */
          .intro-animation-wrapper {
            width: 40vw;
            max-width: 550px;
          }

          @media (max-width: 1024px) {
            .intro-animation-wrapper {
              width: 60vw;
            }
          }

          @media (max-width: 768px) {
            .intro-animation-wrapper {
              width: 85vw;
              max-width: 90vw;
            }
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to   { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  initialOverlay: {
    position: "fixed",
    inset: 0,
    background: "#1A1A1A",
    zIndex: 999999,
  },
  wrapper: {
    position: "fixed",
    inset: 0,
    background: "#1A1A1A",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999999,
    transition: "transform 0.6s ease-in-out",
  },
  slideUp: {
    transform: "translateY(-100%)",
    background: "#1A1A1A",
  },
  animationWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default Intro;
